'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$23(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_GroupsView$$anon$23 as $c_Lpresto_GroupsView$$anon$23 };
$p = $c_Lpresto_GroupsView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$23;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$23() {
}
export { $h_Lpresto_GroupsView$$anon$23 as $h_Lpresto_GroupsView$$anon$23 };
$h_Lpresto_GroupsView$$anon$23.prototype = $p;
$p.aR = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.j9, $j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().csj());
});
var $d_Lpresto_GroupsView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$23, "presto.GroupsView$$anon$23", ({
  JE: 1,
  A: 1
}));
export { $d_Lpresto_GroupsView$$anon$23 as $d_Lpresto_GroupsView$$anon$23 };
//# sourceMappingURL=presto.-Groups-View$$anon$23.js.map
